(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4cc0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4cc0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("451Sc", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $2f891507bcc3501a$export$6503ec6e8aabbaf; }, function (v) { return $2f891507bcc3501a$export$6503ec6e8aabbaf = v; });
var $2f891507bcc3501a$export$6503ec6e8aabbaf;
var $2f891507bcc3501a$export$f7ad0328861e2f03;
"use strict";
var $2f891507bcc3501a$var$mapping = new Map();
function $2f891507bcc3501a$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$2f891507bcc3501a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $2f891507bcc3501a$var$resolve(id) {
    var resolved = $2f891507bcc3501a$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$2f891507bcc3501a$export$6503ec6e8aabbaf = $2f891507bcc3501a$var$register;
$2f891507bcc3501a$export$f7ad0328861e2f03 = $2f891507bcc3501a$var$resolve;

});

parcelRegister("i1aqH", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $d1e0691a4ecd19e1$export$bdfd709ae4826697; }, function (v) { return $d1e0691a4ecd19e1$export$bdfd709ae4826697 = v; });
var $d1e0691a4ecd19e1$export$bdfd709ae4826697;
var $d1e0691a4ecd19e1$export$c9e73fbda7da57b6;
var $d1e0691a4ecd19e1$export$5a759dc7a1cfb72a;
"use strict";
var $d1e0691a4ecd19e1$var$bundleURL = {};
function $d1e0691a4ecd19e1$var$getBundleURLCached(id) {
    var value = $d1e0691a4ecd19e1$var$bundleURL[id];
    if (!value) {
        value = $d1e0691a4ecd19e1$var$getBundleURL();
        $d1e0691a4ecd19e1$var$bundleURL[id] = value;
    }
    return value;
}
function $d1e0691a4ecd19e1$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $d1e0691a4ecd19e1$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $d1e0691a4ecd19e1$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $d1e0691a4ecd19e1$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$d1e0691a4ecd19e1$export$bdfd709ae4826697 = $d1e0691a4ecd19e1$var$getBundleURLCached;
$d1e0691a4ecd19e1$export$c9e73fbda7da57b6 = $d1e0691a4ecd19e1$var$getBaseURL;
$d1e0691a4ecd19e1$export$5a759dc7a1cfb72a = $d1e0691a4ecd19e1$var$getOrigin;

});

var $ca6f3bf2642479cf$exports = {};


(parcelRequire("451Sc")).register((parcelRequire("i1aqH")).getBundleURL("fpWVY"), JSON.parse('["fpWVY","index.f74d2be1.js","kloQM","Icon-Phone-call.2065ff98.png","a8aik","Icon-Burger-menu.fdf49836.png","dISZp","header-logo.10e4bc11.png","flUrz","Icon-Phone-call-dark.06229393.png","d5mGv","Icon-Burger-menu-dark.72c84e5f.png","bjJfs","Icon-Close-dark.a660d1f5.png","gbDUp","header-logo-dark.a4d48ba4.png","cjHTF","Icon-Close.f5c91ce9.svg"]'));

"use strict";
var $197cd56b15c33885$var$page = document.documentElement;
var $197cd56b15c33885$var$switcher = $197cd56b15c33885$var$page.querySelector(".theme-switcher");
var $197cd56b15c33885$var$topBarIconCall = $197cd56b15c33885$var$page.querySelector(".top-bar__icon-call");
var $197cd56b15c33885$var$topBarIconBurger = $197cd56b15c33885$var$page.querySelector(".top-bar__icon-burger");
var $197cd56b15c33885$var$topBarIconClose = $197cd56b15c33885$var$page.querySelector(".top-bar__icon-close");
var $197cd56b15c33885$var$headerLogo = $197cd56b15c33885$var$page.querySelector(".header__logo");
var $197cd56b15c33885$var$menuLogo = document.querySelector(".menu .header__logo");
var $197cd56b15c33885$var$contactInputName = document.querySelector(".contacts__input-name");
var $197cd56b15c33885$var$contactInputEmail = document.querySelector(".contacts__input-email");
var $197cd56b15c33885$var$contactInputTextArea = document.querySelector(".contacts__input-textarea");
var $a22d0f8cb832041a$exports = {};

$a22d0f8cb832041a$exports = (parcelRequire("i1aqH")).getBundleURL("fpWVY") + "Icon-Phone-call-dark.06229393.png";


var $c914eb568cb7a1c6$exports = {};

$c914eb568cb7a1c6$exports = (parcelRequire("i1aqH")).getBundleURL("fpWVY") + "Icon-Phone-call.2065ff98.png";


var $add4910c45b9adda$exports = {};

$add4910c45b9adda$exports = (parcelRequire("i1aqH")).getBundleURL("fpWVY") + "Icon-Burger-menu-dark.72c84e5f.png";


var $63dc74d93679af27$exports = {};

$63dc74d93679af27$exports = (parcelRequire("i1aqH")).getBundleURL("fpWVY") + "Icon-Burger-menu.fdf49836.png";


var $bcd9735cc6926e7d$exports = {};

$bcd9735cc6926e7d$exports = (parcelRequire("i1aqH")).getBundleURL("fpWVY") + "Icon-Close-dark.a660d1f5.png";


var $5f9d9e8a1725eae2$exports = {};

$5f9d9e8a1725eae2$exports = (parcelRequire("i1aqH")).getBundleURL("fpWVY") + "Icon-Close.f5c91ce9.svg";


var $c9673dc1d6aef595$exports = {};

$c9673dc1d6aef595$exports = (parcelRequire("i1aqH")).getBundleURL("fpWVY") + "header-logo-dark.a4d48ba4.png";


var $6865113abf3b74c4$exports = {};

$6865113abf3b74c4$exports = (parcelRequire("i1aqH")).getBundleURL("fpWVY") + "header-logo.10e4bc11.png";


$197cd56b15c33885$var$switcher.addEventListener("click", function() {
    if ($197cd56b15c33885$var$page.classList.contains("page--dark")) {
        $197cd56b15c33885$var$page.classList.remove("page--dark");
        $197cd56b15c33885$var$switcher.classList.remove("switcher--dark");
        $197cd56b15c33885$var$topBarIconCall.src = $c914eb568cb7a1c6$exports;
        $197cd56b15c33885$var$topBarIconBurger.src = $63dc74d93679af27$exports;
        $197cd56b15c33885$var$topBarIconClose.src = $5f9d9e8a1725eae2$exports;
        $197cd56b15c33885$var$headerLogo.src = $6865113abf3b74c4$exports;
        $197cd56b15c33885$var$menuLogo.src = $6865113abf3b74c4$exports;
    } else {
        $197cd56b15c33885$var$page.classList.add("page--dark");
        $197cd56b15c33885$var$switcher.classList.add("switcher--dark");
        $197cd56b15c33885$var$topBarIconCall.src = $a22d0f8cb832041a$exports;
        $197cd56b15c33885$var$topBarIconBurger.src = $add4910c45b9adda$exports;
        $197cd56b15c33885$var$topBarIconClose.src = $bcd9735cc6926e7d$exports;
        $197cd56b15c33885$var$headerLogo.src = $c9673dc1d6aef595$exports;
        $197cd56b15c33885$var$menuLogo.src = $c9673dc1d6aef595$exports;
        $197cd56b15c33885$var$contactInputName.style = "color: rgb(50, 126, 131)";
        $197cd56b15c33885$var$contactInputEmail.style = "color: rgb(50, 126, 131)";
        $197cd56b15c33885$var$contactInputTextArea.style = "color: rgb(50, 126, 131)";
    }
});

})();
//# sourceMappingURL=index.f74d2be1.js.map
